import LegalLayout from './LegalLayout';

const P = ({ children }: { children: React.ReactNode }) => (
  <span className="legal-placeholder">{children}</span>
);

export default function Imprint() {
  return (
    <LegalLayout title="Imprint" lastUpdated="2026-06-18">
      <p>
        Information disclosed pursuant to Slovak Act No. 22/2004 Coll. on
        Electronic Commerce, German § 5 Telemediengesetz (TMG), and Austrian
        § 5 E-Commerce Act (ECG).
      </p>

      <h2>Operator</h2>
      <ul>
        <li><strong>Legal name:</strong> <P>[YOUR LEGAL COMPANY NAME, s.r.o.]</P></li>
        <li><strong>Registered office:</strong> <P>[STREET, POSTAL CODE, CITY, COUNTRY]</P></li>
        <li><strong>Company registration no. (IČO):</strong> <P>[IČO]</P></li>
        <li><strong>VAT ID (DIČ / IČ DPH):</strong> <P>[DIČ / IČ DPH or "Not VAT registered"]</P></li>
        <li><strong>Commercial register:</strong> <P>[e.g., Okresný súd Bratislava I, oddiel: Sro, vložka č.: XXXXX/B]</P></li>
        <li><strong>Represented by:</strong> <P>[STATUTORY REPRESENTATIVE NAME, title]</P></li>
      </ul>

      <h2>Contact</h2>
      <ul>
        <li><strong>Email:</strong> <a href="mailto:contact@rentnova.app">contact@rentnova.app</a></li>
        <li><strong>Phone:</strong> <P>[OPTIONAL PHONE NUMBER]</P></li>
      </ul>

      <h2>Supervisory authority</h2>
      <p>
        <P>[e.g., Slovenská obchodná inšpekcia, Inšpektorát SOI pre Bratislavský kraj]</P>
      </p>

      <h2>Online dispute resolution</h2>
      <p>
        The European Commission provides a platform for online dispute
        resolution available at{' '}
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer">
          ec.europa.eu/consumers/odr
        </a>. We are not obliged and not willing to participate in dispute
        resolution proceedings before a consumer arbitration board.
      </p>

      <h2>Disclaimer / Liability for content</h2>
      <p>
        As a service provider, we are responsible under general law for our own
        content on these pages. We are however not obligated to monitor
        transmitted or stored third-party information or to investigate
        circumstances that indicate illegal activity. Obligations to remove or
        block the use of information under the general laws remain unaffected.
        Any liability in this regard is only possible from the point in time at
        which we become aware of a specific infringement. Upon becoming aware
        of corresponding infringements, we will remove this content
        immediately.
      </p>

      <h2>Liability for links</h2>
      <p>
        Our pages may contain links to external websites of third parties on
        whose content we have no influence. Therefore, we cannot assume any
        liability for these external contents. The respective provider or
        operator of the linked pages is always responsible for their content.
      </p>

      <h2>Copyright</h2>
      <p>
        The content and works created by the site operator on these pages are
        subject to copyright law. Duplication, processing, distribution, or any
        form of commercialization beyond the scope of copyright law requires
        the prior written consent of the respective author or creator.
      </p>
    </LegalLayout>
  );
}
